import { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { PerModal } from '../../../components/custom_components/Modal'
import PerText from '../../../components/custom_components/Text'

interface Props {
  isModalOpen: boolean
  isSubmitting: boolean
  monthYear: string
  closeModal: () => void
  handleConfirm: () => void
}

export const ConfirmTargetBonusAmountModal: FC<Props> = ({ isModalOpen, closeModal, handleConfirm, monthYear, isSubmitting }) => {
  const [t] = useTranslation()

  return (
    <PerModal
      centered
      visible={isModalOpen}
      onCancel={closeModal}
      title={{
        heading: t('appraisalMeeting.contract.changes.confirmBonusAmountModal'),
      }}
      footer={{
        confirmBtn: { onClick: handleConfirm, disabled: isSubmitting, isProcessing: { active: isSubmitting } },
        cancelBtn: { onClick: closeModal },
      }}
    >
      <Trans i18nKey="appraisalMeeting.contract.changes.confirmBonusAmountModalT1" values={{ date: monthYear }} components={[<b></b>]} />
      <PerText>{t('appraisalMeeting.contract.changes.confirmBonusAmountModalT2')}</PerText>
      <PerText>{t('appraisalMeeting.contract.changes.confirmBonusAmountModalT3')}</PerText>
    </PerModal>
  )
}
